import { useContext, useEffect, useState } from 'react';
import { SourceContext } from '../../utils/sourceContext';
import { getCachedState, initUserState } from '../../utils/stateContext';
import Header from '../.shared/header/header';
import Footer from '../.shared/footer/footer';
import Steps from './Steps';
import FeaturedIn from './FeaturedIn';
import Support from './Support';
import SuccessStories from './SuccessStories';
import OriginalHero from './OriginalHero';
import LegitScriptBanner from '../.shared/LegitScriptBanner/LegitScriptBanner';
import PriceUpdateBanner from './PriceUpdateBanner/PriceUpdateBanner';

function Landing() {
    const { source, safeSource, switchAndSave } = useContext(SourceContext);
    const [userState, setUserState] = useState(getCachedState);
    const NON_SWITCH_AND_SAVE_STATES = (() => { try { return JSON.parse(process.env.REACT_APP_NON_SWITCH_AND_SAVE_STATES || '[]'); } catch { return []; } })();
    const stateBlocked = NON_SWITCH_AND_SAVE_STATES.length > 0 && NON_SWITCH_AND_SAVE_STATES.includes(userState);

    useEffect(() => {
        if (NON_SWITCH_AND_SAVE_STATES.length > 0) {
            initUserState().then(() => setUserState(getCachedState()));
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!NON_SWITCH_AND_SAVE_STATES || NON_SWITCH_AND_SAVE_STATES.length === 0) {
        return (
            <>
                {switchAndSave && <PriceUpdateBanner />}
                <Header hideNavigation={source !== 'tb2'}/>
                <OriginalHero safeSource={safeSource} switchAndSaveSource={switchAndSave} showSeal={source === 'benefithub' || source === 'cigna'} />
                <FeaturedIn safeSource={safeSource} />
                <Steps switchAndSaveSource={switchAndSave} />
                <Support />
                <SuccessStories safeSource={safeSource} />
                <LegitScriptBanner />
                <Footer />
            </>
        );
    }

    if (userState === null) return null;

    return (
        <>
            {switchAndSave && !stateBlocked && <PriceUpdateBanner />}
            <Header hideNavigation={source !== 'tb2'}/>
            <OriginalHero safeSource={safeSource} switchAndSaveSource={switchAndSave && !stateBlocked} showSeal={source === 'benefithub' || source === 'cigna'} />
            <FeaturedIn safeSource={safeSource} />
            <Steps switchAndSaveSource={switchAndSave && !stateBlocked} />
            <Support />
            <SuccessStories safeSource={safeSource} />
            <LegitScriptBanner />
            <Footer />
        </>
    );
}

export default Landing;
